module.exports = __webpack_public_path__ + "img/success.2c970bbf.png";